import React, { useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader.jsx";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader.jsx";
import { Radio } from "../../../stories/Radio/Radio";
import { Input } from "../../../stories/Input/Input.jsx";
import { Footer } from "../../../stories/Footer/Footer.jsx";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./ContactUsMobile.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { HeadingBg, faqIcon } from "../../../constant/imagePath";
import { DropDown } from "../../../stories/DropDown/DropDown.jsx";
import { TextArea } from "../../../stories/TextArea/TextArea.jsx";
import { Button } from "../../../stories/Button/Button.jsx";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter.jsx";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader.jsx";
import InputCssClasses from "../../../stories/Input/input.module.css";
import CommonQuestionsCssClasses from "../../../stories/CommonQuestions/commonQuestions.module.css";
import RadioCssClasses from "../../../stories/Radio/Radio.module.css";

const ContactUsMobile = ({ SubmitForm }) => {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [topic, setTopic] = useState();
  const [message, setMessage] = useState();
  const [role, setRole] = useState("Student");
  return (
    <>
      <style jsx>{`
        .${RadioCssClasses.radioWithLabel} {
          width: 100%;
        }
        // .${InputCssClasses.inputBox} {
        //   padding: 16px;
        // }
        // .${CommonQuestionsCssClasses.commonQuestions} h4 {
        //   margin: 24px 0px;
        // }
        // .accordion-button {
        //   padding: 24px 0px 16px 0px !important;
        // }
      `}</style>
      <div className={classes.contactUs}>
        <Container fluid className="p-0">
          <Row className={`gx-0 ${classes.mainContent}`}>
            <Col md={12} className={classes.header}>
              <MobileHeader
                isAvatar={true}
                isLogo={true}
                avatarStyle={{ fontSize: "10px" }}
              />
            </Col>

            <Col md={12} className={classes.formCol}>
              <h2
                className={classes.formHeading}
                style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
              >
                <span style={{ position: "relative" }}>
                  Contact&nbsp;&nbsp;&nbsp;
                  <img src={HeadingBg} />
                </span>{" "}
                Us
              </h2>

              {/* Form Row */}
              <Row>
                <Col md={12} className={classes.mb32}>
                  <p style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}>
                    Your role
                  </p>
                  <div className={classes.roleRadios}>
                    <Radio
                      label="Student"
                      value={role}
                      setter={() => setRole("Student")}
                    />
                    <Radio
                      label="Coach"
                      value={role}
                      setter={() => setRole("Coach")}
                    />
                  </div>
                </Col>
                <Col md={6} className={classes.mb32}>
                  <Input
                    label={"First Name"}
                    state={firstName}
                    setter={setFirstName}
                    type="text"
                    placeholder={""}
                  />
                </Col>
                <Col md={6} className={classes.mb32}>
                  <Input
                    label={"Last Name"}
                    state={lastName}
                    setter={setLastName}
                    type="text"
                    placeholder={""}
                  />
                </Col>
                <Col md={6} className={classes.mb32}>
                  <Input
                    label={"Email"}
                    state={email}
                    setter={setEmail}
                    type="text"
                    placeholder={""}
                  />
                </Col>
                <Col md={6} className={classes.mb32}>
                  <DropDown
                    label={"Topic"}
                    state={topic}
                    setter={setTopic}
                    placeholder={"Select One"}
                    options={[
                      {
                        value: "I have a question about my profile",
                        label: "I have a question about my profile",
                      },
                      {
                        value: "I had problems with the lesson",
                        label: "I had problems with the lesson",
                      },
                      {
                        value: "I have a payment issue",
                        label: "I have a payment issue",
                      },
                      {
                        value: "I’m trying to find a coach",
                        label: "I’m trying to find a coach",
                      },
                      {
                        value: "I have a bug to report",
                        label: "I have a bug to report",
                      },
                      { value: "Other", label: "Other" },
                    ]}
                  />
                </Col>
                <Col md={12} className={classes.mb32}>
                  <TextArea
                    label={"Your Message"}
                    state={message}
                    setter={setMessage}
                    textAreaStyle={{ minHeight: "164px", maxHeight: "164px" }}
                    placeholder={""}
                  />
                </Col>
                <Col md={12}>
                  <Button
                    label={"Get in touch"}
                    primary={true}
                    size={"Large"}
                    customStyle={
                      {
                        //   padding: "12px 32px 12px 32px",
                        // height: "56px",
                        // width: "158px",
                      }
                    }
                    onClick={() => {
                      SubmitForm({
                        email,
                        topic,
                        message,
                        role,
                        firstName,
                        lastName,
                      });
                    }}
                  />
                </Col>
                <Col md={12}>
                  <p
                    className={classes.needHelp}
                    style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                  >
                    Need Help? Visit our{" "}
                    <span
                      style={{ ...Fonts.p1, color: Colors.mainCeruleanBlue }}
                    >
                      Help Center
                    </span>
                  </p>
                </Col>
              </Row>
            </Col>

            <Col md={12} className="footerContainer">
              <MobileFooter />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ContactUsMobile;
